import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { authClient } from './lib/auth';
import { queryClient } from './lib/queryClient';
import { router } from './routes';
// eslint-disable-next-line import/no-unassigned-import -- a stylesheet has nothing to bind; Vite wants the bare import
import './index.css';

const container = document.getElementById('root');
if (container === null) {
  // Nothing useful can happen without it, and a silent blank page is the worst
  // possible failure mode to debug.
  throw new Error('index.html is missing <div id="root">');
}

// A refresh that 401s means the session is gone. Drop every cached tenant row
// and refetch what is on screen, so `/me` answers 401 and RequireAuth redirects.
authClient.on('auth:session_expired', () => {
  void queryClient.resetQueries();
});

void authClient.initialize().finally(() => {
  createRoot(container).render(
    <StrictMode>
      {/*
        QueryClientProvider sits above the router: the cache must outlive any single
        route, otherwise navigating away and back refetches everything.
      */}
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
});
